const domainsWithBackend: Array<string> = ['localhost'];

export const useBackend = domainsWithBackend.includes(window.location.hostname);

export default domainsWithBackend;
